import Waypoint from 'waypoints';

const mapActiveClass = 'js-map-animation--active';
const mapEnabledClass = 'interactive-map-enabled';

class InteractiveMap {
  constructor(mapContainer, waypointContainer) {
    this.waypointContainer = waypointContainer;
    this.mapContainer = mapContainer;
  }

  init() {
    this.mapContainer.classList.add(mapEnabledClass);
    this.bindWaypoint();
  }

  mapFallback() {
    this.mapContainer.classList.remove(mapEnabledClass);
    const globe = this.mapContainer.querySelector('.map__globe-wrapper');
    globe.parentElement.removeChild(globe);
    return (typeof this.mapApp === 'object') ? this.mapApp.destroy() : null;
  }

  bindWaypoint() {
    const waypoint = new Waypoint({
      element: this.waypointContainer,
      offset: '100%',
      handler: (dir) => {
        if (dir !== 'down') {
          return;
        }

        this.handleWaypointTriggered();
        waypoint.disable();
      },
    });
  }

  handleMapError(error = 'an error occured fetching map data') {
    window.bugsnagClient.notify(error);
    this.mapFallback();
  }

  onMapAppLoad({default: MapApp}) {
    this.pauseButton = this.mapContainer.querySelector('.map__control--pause');
    this.playButton = this.mapContainer.querySelector('.map__control--play');

    const mapElem = this.mapContainer.querySelector('#Map');
    this.mapApp = new MapApp(mapElem, mapElem.dataset.start, this.handleMapError.bind(this));

    this.mapContainer.classList.add(mapActiveClass);

    this.pauseButton.addEventListener('click', this.pause.bind(this));
    this.playButton.addEventListener('click', this.play.bind(this));
  }

  pause() {
    this.mapApp.pause()
      .then(() => {
        this.mapContainer.classList.remove(mapActiveClass);
        this.playButton.focus();
      })
      .catch((error) => window.bugsnagClient.notify(error));
  }

  play() {
    this.mapApp.play()
      .then(() => {
        this.mapContainer.classList.add(mapActiveClass);
        this.pauseButton.focus();
      })
      .catch((error) => window.bugsnagClient.notify(error));
  }

  handleWaypointTriggered() {
    import(/* webpackChunkName: "map-app/MapApp" */'../map-app/MapApp')
      .then(this.onMapAppLoad.bind(this))
      .catch(this.handleMapError.bind(this));
  }
}

export default InteractiveMap;
